import { render, staticRenderFns } from "./datepicker.html?vue&type=template&id=4882f95f&scoped=true&"
import script from "./datepicker.js?vue&type=script&lang=js&"
export * from "./datepicker.js?vue&type=script&lang=js&"
import style0 from "./datepicker.scss?vue&type=style&index=0&id=4882f95f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882f95f",
  null
  
)

export default component.exports